export default {
  lang: {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
  },

  nav: {
    home: 'Startseite',
    services: 'Dienstleistungen',
    about: 'Über uns',
    contact: 'Kontakt',
    quote: 'Offerte anfordern',
  },

  footer: {
    tagline:
      'Professionelle Reinigungs- und Facility-Dienstleistungen für Privat- und Geschäftskunden. Wir halten Ihre Räume mit Sorgfalt und Präzision sauber, gesund und gepflegt.',
    quickLinks: 'Schnellzugriff',
    ourServices: 'Unsere Dienstleistungen',
    contactInfo: 'Kontakt',
    address: "Rte de Rosé 51, 1754 Avry-sur-Matran, Schweiz",
    privacy: 'Datenschutz',
    terms: 'AGB',
    rights: 'Alle Rechte vorbehalten.',
    services: [
      'Professionelle Reinigung',
      'Gebäudeunterhalt',
      'Concierge-Dienste',
      'Pflege der Aussenbereiche',
      'Spezialreinigung',
      'Facility Management',
    ],
  },

  hero: {
    badge: 'Über 5’000 zufriedene Kunden in der ganzen Schweiz',
    titleLine1: 'Ein sauberer Raum ist ein',
    titleLine2: 'glücklicher Raum',
    subtitle:
      'Limpia Sàrl bietet professionelle, umweltfreundliche Reinigungsdienstleistungen für Privat- und Geschäftskunden. Erleben Sie die Freude an einer makellosen, frischen Umgebung — jedes Mal aufs Neue.',
    ctaQuote: 'Kostenlose Offerte',
    ctaServices: 'Dienstleistungen entdecken',
    scroll: 'Zum Entdecken scrollen',
  },

  servicesOverview: {
    badge: 'Unser Angebot',
    title: 'Professionelle Reinigungsdienstleistungen',
    subtitle:
      'Von der täglichen Pflege bis zur Tiefenreinigung bieten wir ein umfassendes Angebot an Reinigungslösungen, die auf Ihre Bedürfnisse zugeschnitten sind.',
    items: [
      {
        icon: 'ri-sparkling-2-line',
        title: 'Professionelle Reinigung',
        description: 'Sorgfältige, regelmässige Reinigung für täglich saubere, gesunde und angenehme Räume.',
        features: ['Büroreinigung', 'Gebäudereinigung', 'Regelmässig oder punktuell'],
      },
      {
        icon: 'ri-building-line',
        title: 'Gebäudeunterhalt',
        description: 'Tägliche Pflege Ihrer Gebäude, um Sauberkeit, Komfort und Qualität zu erhalten.',
        features: ['Gemeinschaftsbereiche', 'Treppenhäuser und Gänge', 'Waschküchen'],
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Concierge-Dienste',
        description: 'Ein Service vor Ort für den reibungslosen Betrieb und die laufende Pflege Ihrer Gebäude.',
        features: ['Kontrolle der Gemeinschaftsbereiche', 'Abfallmanagement', 'Kleinere Unterhaltsarbeiten'],
      },
      {
        icon: 'ri-plant-line',
        title: 'Pflege der Aussenbereiche',
        description: 'Wir halten Ihre Aussenbereiche das ganze Jahr über sauber, gepflegt und einladend.',
        features: ['Pflege der Grünflächen', 'Rasenmähen', 'Heckenschnitt'],
      },
      {
        icon: 'ri-brush-line',
        title: 'Spezialreinigung',
        description: 'Einsätze für Situationen, die besondere Aufmerksamkeit und Tiefenreinigung erfordern.',
        features: ['Reinigung nach Bauarbeiten', 'Reinigung nach Umzug', 'Tiefenreinigung'],
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Facility Management',
        description: 'Professionelle Koordination der Unterhaltsleistungen für Ihre Gebäude.',
        features: ['Koordination der Einsätze', 'Leistungsüberwachung', 'Planung der Reinigung'],
      },
    ],
  },

  stats: {
    labels: ['Jahre Erfahrung', 'Zufriedene Kunden', 'Fachpersonal', 'Zufriedenheitsrate'],
  },

  why: {
    badge: 'Warum Limpia',
    titleLine1: 'Saubere Räume,',
    titleLine2: 'glückliche Gesichter',
    subtitle:
      'Wir sind nicht einfach ein weiteres Reinigungsunternehmen. Wir sind Ihr Partner für ein gesünderes und angenehmeres Umfeld — ob zu Hause oder im Geschäft.',
    rating: 'Durchschnittliche Bewertung',
    items: [
      {
        icon: 'ri-leaf-line',
        title: 'Umweltfreundliche Produkte',
        description: 'Wir verwenden biologisch abbaubare, ungiftige Reinigungsmittel, die für Ihre Familie, Haustiere und den Planeten sicher sind.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Versichert & geschützt',
        description: 'Vollständiger Versicherungsschutz und geprüftes Personal geben Ihnen bei jedem Einsatz ein beruhigendes Gefühl.',
      },
      {
        icon: 'ri-user-star-line',
        title: 'Geschultes Fachpersonal',
        description: 'Jedes Teammitglied durchläuft eine gründliche Schulung und Hintergrundprüfung, bevor es Ihre Räume betritt.',
      },
      {
        icon: 'ri-thumb-up-line',
        title: 'Zufriedenheitsgarantie',
        description: 'Nicht zufrieden? Wir kommen zurück und machen es richtig — ohne Fragen und ohne Aufpreis.',
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Flexible Terminplanung',
        description: 'Buchen Sie wöchentlich, zweiwöchentlich, monatlich oder einmalig. Morgens, nachmittags oder abends — wir passen uns an.',
      },
      {
        icon: 'ri-money-euro-circle-line',
        title: 'Faire Preise',
        description: 'Transparente, klare Preise ohne versteckte Gebühren. Qualität, die zu Ihrem Budget passt.',
      },
    ],
  },

  testimonials: {
    badge: 'Kundenstimmen',
    title: 'Das sagen unsere Kunden',
    subtitle: 'Echtes Feedback von echten Menschen, die uns ihre Räume anvertrauen.',
    items: [
      {
        name: 'Sophie Lambert',
        role: 'Hausbesitzerin',
        content:
          'Limpia reinigt meine Wohnung seit über zwei Jahren. Das Team ist immer pünktlich, äusserst gründlich, und die umweltfreundlichen Produkte beruhigen mich — besonders mit zwei kleinen Kindern zu Hause.',
      },
      {
        name: 'Marc Dubois',
        role: 'Büroleiter',
        content:
          'Wir haben vor sechs Monaten für unsere Büroreinigung zu Limpia gewechselt, und der Unterschied ist wie Tag und Nacht. Unsere Räume sahen nie besser aus, und das Team ist professionell und diskret. Sehr zu empfehlen.',
      },
      {
        name: 'Claire Muller',
        role: 'Immobilienverwalterin',
        content:
          'Als Verwalterin mehrerer Gebäude brauche ich einen Reinigungspartner, auf den ich mich verlassen kann. Limpia überzeugt jedes Mal — zuverlässig, konstant und mit herausragender Liebe zum Detail.',
      },
      {
        name: 'Thomas Weber',
        role: 'Restaurantbesitzer',
        content:
          'Sauberkeit ist im Restaurantgeschäft alles. Limpia erledigt unsere Tiefenreinigungen präzise und sorgfältig. Sie verstehen unsere Anforderungen und übertreffen stets die Erwartungen.',
      },
    ],
  },

  quote: {
    badge: 'Jetzt starten',
    title: 'Bereit für einen saubereren Raum?',
    subtitle:
      'Teilen Sie uns Ihre Reinigungsbedürfnisse mit, und wir melden uns innerhalb von 24 Stunden mit einer persönlichen Offerte. Unverbindlich und ohne Druck — einfach ein makelloser Raum.',
    points: ['Kostenlose, unverbindliche Offerte', 'Antwort innerhalb von 24 Stunden', 'Auf Ihre Bedürfnisse zugeschnitten'],
    form: {
      name: 'Vollständiger Name',
      namePlaceholder: 'Ihr vollständiger Name',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'sie@beispiel.de',
      phone: 'Telefonnummer',
      phonePlaceholder: '+41 ...',
      service: 'Art der Dienstleistung',
      servicePlaceholder: 'Dienstleistung auswählen...',
      serviceOptions: [
        'Professionelle Reinigung',
        'Gebäudeunterhalt',
        'Concierge-Dienste',
        'Pflege der Aussenbereiche',
        'Spezialreinigung',
        'Facility Management',
      ],
      message: 'Erzählen Sie uns von Ihren Bedürfnissen',
      messagePlaceholder: 'Beschreiben Sie Ihre Räume, den gewünschten Zeitplan und besondere Anforderungen...',
      submit: 'Kostenlose Offerte anfordern',
    },
    success: {
      title: 'Vielen Dank!',
      message: 'Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.',
    },
    error: {
      title: 'Hoppla!',
      tryAgain: 'Erneut versuchen',
      network: 'Netzwerkfehler. Bitte versuchen Sie es später erneut.',
    },
  },

  servicesPage: {
    header: {
      badge: 'UNSERE DIENSTLEISTUNGEN',
      title: 'Professionelle Lösungen für Ihre Gebäude und Räume',
      description:
        'Limpia Sàrl begleitet Sie mit Reinigungs-, Unterhalts- und Concierge-Dienstleistungen, die auf die Bedürfnisse von Privatpersonen, Unternehmen, Eigentümern und Immobilienverwaltungen zugeschnitten sind.',
    },
    learnMore: 'Mehr erfahren',
    items: [
      {
        title: 'Professionelle Reinigung',
        description: 'Sorgfältige, regelmässige Reinigung für täglich saubere, gesunde und angenehme Räume.',
        imageAlt: 'Professionelle Büroreinigung durch Limpia Sàrl',
        features: [
          'Büroreinigung',
          'Gebäudereinigung',
          'Reinigung von Gewerbeflächen',
          'Regelmässig oder punktuell',
        ],
      },
      {
        title: 'Gebäudeunterhalt',
        description: 'Wir übernehmen die tägliche Pflege Ihrer Gebäude, um deren Sauberkeit, Komfort und Qualität zu erhalten.',
        imageAlt: 'Gebäudeunterhalt — Gemeinschaftsbereiche durch Limpia Sàrl',
        features: [
          'Gemeinschaftsbereiche',
          'Treppenhäuser und Gänge',
          'Keller und Gemeinschaftsräume',
          'Waschküchen',
          'Garagen und Parkplätze',
        ],
      },
      {
        title: 'Concierge-Dienste',
        description: 'Ein Service vor Ort für den reibungslosen Betrieb und die laufende Instandhaltung Ihrer Gebäude.',
        imageAlt: 'Concierge-Dienste durch Limpia Sàrl',
        features: [
          'Kontrolle der Gemeinschaftsbereiche',
          'Abfallmanagement',
          'Kleinere Unterhaltsarbeiten',
          'Überwachung des Gebäudebedarfs',
          'Meldung möglicher Probleme',
        ],
      },
      {
        title: 'Pflege der Aussenbereiche',
        description: 'Wir halten Ihre Aussenbereiche das ganze Jahr über sauber, gepflegt und einladend.',
        imageAlt: 'Pflege der Aussenbereiche durch Limpia Sàrl',
        features: ['Pflege der Grünflächen', 'Rasenmähen', 'Heckenschnitt', 'Reinigung der Aussenbereiche'],
      },
      {
        title: 'Spezialreinigung',
        description: 'Massgeschneiderte Einsätze für Situationen, die besondere Aufmerksamkeit und Tiefenreinigung erfordern.',
        imageAlt: 'Spezialreinigung nach Bauarbeiten durch Limpia Sàrl',
        features: [
          'Reinigung nach Bauarbeiten',
          'Reinigung nach Umzug',
          'Tiefenreinigung',
          'Punktuelle Einsätze',
        ],
      },
      {
        title: 'Facility Management',
        description: 'Professionelle Koordination der Unterhaltsleistungen zur Vereinfachung der täglichen Gebäudeverwaltung.',
        imageAlt: 'Facility Management durch Limpia Sàrl',
        features: [
          'Koordination der Einsätze',
          'Leistungsüberwachung',
          'Planung der Reinigung',
          'Lösungen für Eigentümer und Verwaltungen',
        ],
      },
    ],
    cta: {
      title: 'Brauchen Sie eine auf Ihr Gebäude zugeschnittene Lösung?',
      text: 'Sprechen wir über Ihre Bedürfnisse und finden wir gemeinsam eine passende Unterhaltslösung.',
      button: 'Offerte anfordern',
      secondary: 'Kontaktieren Sie uns',
    },
  },

  about: {
    badge: 'Wer wir sind',
    title: 'Über Limpia Sàrl',
    subtitle:
      'Ein Unternehmen in Ihrer Nähe, das sich der Pflege und Sauberkeit Ihrer Gebäude und Räume widmet.',
    imageAlt: 'Gebäudeunterhalt durch Limpia Sàrl',
    section: {
      headline: 'Ein Unternehmen in Ihrer Nähe, im Dienste Ihrer Gebäude',
      paragraph1:
        'Limpia Sàrl begleitet Eigentümer, Immobilienverwaltungen, Unternehmen und Stockwerkeigentümergemeinschaften bei der Pflege und Sauberkeit ihrer Gebäude und Räume.',
      paragraph2:
        'Unser Ziel ist einfach: einen zuverlässigen, sorgfältigen und auf die Bedürfnisse jedes Kunden zugeschnittenen Service anzubieten. Von der regelmässigen Reinigung bis zur Pflege von Gebäuden und Aussenbereichen bieten wir flexible Lösungen, um täglich saubere, gepflegte und angenehme Umgebungen zu gewährleisten.',
      paragraph3:
        'Im Austausch mit unseren Kunden legen wir Wert auf Qualität der Arbeit, Nähe und eine sorgfältige Begleitung jeder Leistung.',
      highlights: [
        { icon: 'ri-shield-check-line', title: 'Zuverlässigkeit' },
        { icon: 'ri-award-line', title: 'Qualität' },
        { icon: 'ri-hand-heart-line', title: 'Nähe' },
      ],
      cta: 'Mehr erfahren',
    },
  },

  contactPage: {
    badge: 'KONTAKT',
    title: 'Kontaktieren Sie Limpia Sàrl',
    subtitle:
      'Haben Sie eine Frage oder benötigen Sie eine Lösung für Ihr Gebäude? Unser Team hilft Ihnen gerne weiter.',
    phone: 'Telefon',
    email: 'E-Mail',
    address: 'Adresse',
    mapTitle: 'So finden Sie uns',
  },
};